import { z } from "zod";
import { UserSchema } from "./User";
import { BaseChangelogSchema } from "./Changelog";

export const UserChangelogSchema = BaseChangelogSchema.extend({
  oldValue: z.boolean(),
  newValue: z.boolean(),
  editedUserUser: UserSchema,
});
export const PartialUserChangelogSchema = UserChangelogSchema.deepPartial();

export type PartialUserChangelog = z.infer<typeof PartialUserChangelogSchema>;

export type UserChangelog = z.infer<typeof UserChangelogSchema>;
